import { ReactElement } from 'react'

import SelectExtratoImpl from 'modules/pagamentos/domain/usecases/SelectExtratoImpl'
import PagamentoRepository from 'modules/pagamentos/infra/repositories/PagamentoRepository'

import ExportarExtratoImpl from './../../domain/usecases/ExportarExtrato'
import Extrato from '../../pages/Extrato'

export const ExtratoFactory = (): ReactElement => {
  const pagamentoRepository = new PagamentoRepository()
  const selectExtrato = new SelectExtratoImpl(pagamentoRepository)
  const exportarExtratoImpl = new ExportarExtratoImpl(pagamentoRepository)

  return (
    <Extrato
      selectExtrato={selectExtrato}
      exportarExtrato={exportarExtratoImpl}
    />
  )
}
